import type { LotoReportScope } from './lotoReportSchemas'

type ScopedTags = {
  organization: string
  site: string
  'pipeline-config'?: string | null
}

export function lotoScopeTags(scope: LotoReportScope): {
  sandbox: 'sandbox'
  organization: string
  site: string
  'pipeline-config': string
} {
  return {
    sandbox: 'sandbox',
    organization: scope.organization,
    site: scope.site,
    'pipeline-config': scope.pipelineConfig,
  }
}

export function matchesLotoScope(
  tags: ScopedTags,
  scope: LotoReportScope
): boolean {
  return (
    tags.organization === scope.organization &&
    tags.site === scope.site &&
    tags['pipeline-config'] === scope.pipelineConfig
  )
}
